import { useQuery } from "react-query";
import type { UseQueryResult } from "react-query";
import { default as config } from "common/config/config";
import { RoleType } from "common/models/role/Role";
import useUserState from "ui/adapter/state/useUserState";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { programsApi } from "../api/programsApi";

export default function useGetProgramBalance<TData = string>({
    enabled: enableProp = true,
    ...options
}: UseCustomQueryOptions<string, unknown, TData, (string | undefined)[]> = {}): UseQueryResult<TData> {
    const { selectedRole } = useUserState();
    const resourceAddress = selectedRole?.resourceAddress;
    const safeResourceAddress = resourceAddress as string;

    return useQuery(
        [Queries.PROGRAM_BALANCE, resourceAddress],
        async () => {
            const res = await programsApi.getBalance(safeResourceAddress);
            return res.data;
        },
        {
            enabled: enableProp && Boolean(resourceAddress) && selectedRole?.roleType === RoleType.PROGRAM_MANAGER,
            refetchInterval: config.refetchIntervals.balance,
            ...options,
        },
    );
}
